<template>
  <div class="sys-Module-list">
    <div class="table-box" v-loading="loading">
      <Table :columns="columns" :data="tableData">
        <!-- 模块 -->
        <template slot-scope="{row,index}" slot="name">
          <div style="text-align: left;">
            <img :src="row.img" style="width:30px;margin-right:5px">
            <span>{{row.name}}</span>
          </div>
        </template>
        <!-- 操作 -->
        <template slot-scope="{row,index}" slot="action">
          <span v-if="row.isAdded==1">已添加</span>
          <span class="table-btn" v-else-if="moduleCode!='SELF_TOOLBAR'" @click="add(row)">添加</span>
          <Dropdown v-else @on-click="add(row,$event)">
            <a href="javascript:void(0)">
              添加
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem disabled>请选择要添加到的栏目</DropdownItem>
              <DropdownItem name="1">展业工具</DropdownItem>
              <DropdownItem name="2">管理工具</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  mixins:[],
  props: {
  },
  data() {
    return {
      loading:false,
      moduleCode:'',
      tableData:[],
      columns: []
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
  },
  methods: {
    init(moduleCode){
      this.moduleCode = moduleCode;
      const columns = [
        {
          title: "模块",
          slot: "name",
          width: 130,
          align: "center"
        },
        {
          title: "显示文案",
          key: "description",
          minWidth: 200,
          align: "center"
        },
        {
          title: "详细介绍",
          key: "detailIntroduction",
          minWidth: 200,
          align: "center"
        },
        {
          title: "模块",
          slot: "action",
          width: 130,
          align: "center"
        },
      ]
      if(moduleCode != 'EXHIBITION_TOOLBAR'){
        columns.splice(1, 1);
      }
      this.columns = columns;
      this.getList();
    },
    getList(){
      this.loading = true;
      this.$http({
        url: "/buz/mcmMerchantModule/queryDefaultChildModule",
        type: "PUT",
        data: {
          parentModuleCode: this.moduleCode,
        }
      }).then(res => {
        this.loading = false;
        this.tableData = res.data;
      }).catch(e => {
        this.loading = false;
      });
    },
    // 下拉菜单选择
    dropdownClick(toolType, row){

    },
    add(row, toolType) {
      if(this.loading){
        return;
      }
      this.loading = true;
      this.$http({
        url: "/buz/mcmMerchantModule/add",
        type: "POST",
        data: {
          sysModuleId:row.id,
          enable:1,
          parentModuleCode: this.moduleCode,
          toolType: toolType,
        }
      }).then(res => {
        this.loading = false;
        this.$emit("success");
        this.$notice.success("新增工具成功");
      }).catch(e => {
        this.loading = false;
      });
    }
  },

};
</script>
<style lang="scss" scoped>
@import "./phoneIndex.scss";
</style>
